import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
import './Header.scss';

import AnimatedLetters from '../../AnimatedLetters';
import Animation from '../../Animation';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
};

const Header = () => {
  const [letterClass, setLetterClass] = useState('text-animate');

  const intro = ['H', 'e', 'l', 'l', 'o', ',', ' I', ' ', 'a', 'm'];
  const nameArray = ['R', 'A', 'N', 'A', ' ', 'T', 'A', 'L', 'H', 'A'];
  const jobArray1 = [
    'W',
    'E',
    'B',
    ' ',
    'D',
    'E',
    'V',
    'E',
    'L',
    'O',
    'P',
    'E',
    'R',
  ];
  const jobArray2 = ['F', 'R', 'E', 'E', 'L', 'A', 'N', 'C', 'E', 'R'];

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 4000);
  }, []);

  return (
    <div className='app__header app__flex'>
      <Animation aa={0.001} tt={7} />
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className='app__header-info'>
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <h2 className='h2'>
                <AnimatedLetters
                  letterClass={letterClass}
                  strArray={intro}
                  idx={1}
                />
                <br />
                <AnimatedLetters
                  letterClass={letterClass}
                  strArray={nameArray}
                  idx={5}
                />
              </h2>
            </div>
          </div>

          <div className='tag-cmp app__flex'>
            <h4>
              <AnimatedLetters
                letterClass={letterClass}
                strArray={jobArray1}
                idx={17}
              />
              <br />
              <AnimatedLetters
                letterClass={letterClass}
                strArray={jobArray2}
                idx={25}
              />
            </h4>
          </div>
        </div>
      </motion.div>

      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__header-img'>
        <img src={images.coverPhoto} alt='profile_bg' />
        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 1, ease: 'easeInOut' }}
          src={images.circle}
          alt='profile_circle'
          className='overlay_circle'
        />
      </motion.div>

      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className='app__header-circles'>
        {[images.css, images.react, images.javascript].map((circle, index) => (
          <div className='circle-cmp app__flex' key={`circle-${index}`}>
            <img src={circle} alt='profile_bg' />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, 'home');
